import React from "react";
import _ from "lodash";
import formatPnlText from "../Helpers/formatPnl";
import getPnlInfo from "../Helpers/getPnlInfo";

export default function DashboardTable({ setSelectedSegment, data }) {
  const structuredSegments = _.keyBy(data.pnl_data.pl_data, "name");
  // Converts from array of object to single object. Done this for easier rendering of table.
  // Eg: Converts [{name:"Segment1",data:[]},{name:"Segment2",data:[]}] -> {"Segment1":{name:"",data:""},"Segment2":{name:"",data:"}

  return (
    <div className="table-container p-3">
      <div className="main-heading my-3">
        <img
          src="https://assets.fyers.in/verified-pnl/images/icon-table-list.svg"
          className="mr-2"
          alt="title"
        />
        <span>{getPnlInfo(data)}</span>
      </div>
      <div className={`table-wrapper-container mb-5 mb-md-0 ${data.custom_options.hidePosition ? "overflow-hidden min-height-400": ""}`}>
        <table className="table">
          <thead>
            <tr>
              <th className="table-th-name">Name</th>
              <th>Buy qty</th>
              <th>Sell qty</th>
              <th>Net qty</th>
              <th>Realized P&L</th>
              <th>Unrealized P&L</th>
              <th>Total P&L</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(structuredSegments).map((key, i) => {
              return (
                <React.Fragment key={i}>
                  {structuredSegments[key] &&
                  !_.isEmpty(structuredSegments[key].data) ? (
                    <>
                      <tr className="overview-table-heading text-left">
                        <td colSpan={7}>{key}</td>
                      </tr>
                      <>
                        {structuredSegments[key] &&
                          structuredSegments[key].data
                            .slice(0, 5)
                            .map((data, index) => (
                              <tr
                                className={`overview-table-data ${
                                  data.net_qty ? "overview-active-holding" : ""
                                }`}
                                key={index}
                              >
                                <td>{data.symbol}</td>
                                <td className="text-right">{data.buy_qty}</td>
                                <td className="text-right">{data.sell_qty}</td>
                                <td
                                  className={`text-right ${
                                    data.net_qty
                                      ? "overview-active-net-qty"
                                      : ""
                                  }`}
                                >
                                  {data.net_qty}
                                </td>
                                <td className="text-right">
                                  {formatPnlText.withoutColor(data.pl_realized)}
                                </td>
                                <td className="text-right">
                                  {formatPnlText.withoutColor(
                                    data.pl_unrealized
                                  )}
                                </td>
                                <td className="text-right">
                                  {data.net_qty
                                    ? formatPnlText.withColor(data.pl_total)
                                    : formatPnlText.withoutColor(data.pl_total)}
                                </td>
                              </tr>
                            ))}
                      </>
                      {structuredSegments[key].data.length > 5 ? (
                        <tr>
                          <td
                            className="overview-table-view-all text-md-right"
                            colSpan={7}
                            onClick={() => setSelectedSegment(key)}
                          >
                            View all{" "}
                            <img
                              src="https://assets.fyers.in/verified-pnl/images/arrow.svg"
                              alt="arrow"
                            />
                          </td>
                        </tr>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        {
          data.custom_options.hidePosition ? 
          <div className="private-content">
            <div class>
              <img src="https://assets.fyers.in/verified-pnl/images/eye.svg" />
              <div className="header">Private Content</div>
              <p>The user has shared the  verified P&L data anonymously</p>
            </div>
          </div>: null
        }
      </div>
    </div>
  );
}
